import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';

export class AllEvalSetting implements Serializable<AllEvalSetting> {
  evalSettingID: number;
  title: string;
  status: GEnum.ExamStatus;
  startTime: Date;
  deadline: Date;
  questionSettingType: number;
  schoolYear: number;

  deserialize(input: any): AllEvalSetting {
    this.evalSettingID = input.evalSettingID;
    this.title = input.title;
    this.status = input.status;
    if (input.startTime !== undefined) {
      this.startTime = new Date(input.startTime);
    }
    if (input.deadline !== undefined) {
      this.deadline = new Date(input.deadline);
    }
    this.questionSettingType = input.questionSettingType;
    this.schoolYear = input.schoolYear;
    return this;
  }
}
